module.exports = __webpack_public_path__ + "static/media/logo_black.dcea82aa.png";